// extracted by mini-css-extract-plugin
export default {"clip":"ClipIcon_clip__Y3MJe"};